import AbstractGeoLoc from '@phoenix/components/AbstractGeoLoc';
import { emitter, COUNTRY_PROPOSITION_SHOULD_EXPAND } from '@phoenix/event-bus';

export default class GeoLoc extends AbstractGeoLoc {
  static readonly CLOSED_BANNER_STORAGE_KEY = 'closedMarketBanner';

  /**
   * Enable the proposition banner by adding click listeners to the buttons
   */
  showPropositionBanner(): void {
    emitter.emit(COUNTRY_PROPOSITION_SHOULD_EXPAND);

    document.querySelectorAll('.country-proposition-item').forEach((locationButton) => {
      locationButton.addEventListener('click', () => {
        localStorage.setItem(GeoLoc.CLOSED_BANNER_STORAGE_KEY, 'true');
      });
    });
  }

  shouldShowBanner(countryCodeFromIP): boolean {
    return localStorage.getItem(GeoLoc.CLOSED_BANNER_STORAGE_KEY) === null || super.shouldShowBanner(countryCodeFromIP);
  }
}
